export const EIntegrationTypes = {
  FACEBOOK: 1,
  INSTAGRAM: 2,
  VKONTAKTE: 3,
  TWITTER: 4,
  IGFACEBOOK: 5,
  LINKEDIN: 6,
  TELEGRAM: 7,
  ODNOKLASNIKI: 8,
  PINTEREST: 9,
  THREADS: 10,
  DISCORD: 11,
};
